module.exports = __webpack_public_path__ + "img/package-main.df2e20bd.png";